import script from "./DeadlineChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DeadlineChart.vue?vue&type=script&setup=true&lang=js"

import "./DeadlineChart.vue?vue&type=style&index=0&id=24b7ab38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\Code\\ASIC\\MulticaseVue\\MulticaseWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b7ab38"]])

export default __exports__